import { useIntl, useSettings } from '@capsicum/common';
import { Text } from '@capsicum/common-web';
import { ExternalLinkIcon } from '@capsicum/common-web/icons';
import { useShowHeaderWarning } from '@capsicum/features/regulations/shared';
import { type ReactNode } from 'react';
import styled, { useTheme } from 'styled-components';

export const UkTokenChartRiskLink = () => {
	const { $t } = useIntl();
	const { settings } = useSettings();
	const { colors } = useTheme();
	const { shouldShowUkRiskLink } = useShowHeaderWarning();
	const isUkRiskLinkDisplayed = shouldShowUkRiskLink('partner');

	if (!isUkRiskLinkDisplayed) return null;

	return (
		<S.UkRegulationText variant="text2">
			{$t('jurisdictionRequirements.ukRiskWarning.tokenChart', {
				link: (chunks: Array<ReactNode>) => (
					<S.Link data-testid="uk-risk-link" href={settings?.ukRiskLink} target="_blank">
						{chunks}
						<S.ExternalLink color={colors.icons.brand.enabled} height={16} width={16} />
					</S.Link>
				)
			})}
		</S.UkRegulationText>
	);
};

namespace S {
	export const UkRegulationText = styled(Text)`
		text-align: center;
	`;

	export const Link = styled.a`
		color: ${({ theme }) => theme.colors.text.brand.enabled};
		${({ theme }) => theme.fonts.text.text3};
		text-decoration: underline;
	`;

	export const ExternalLink = styled(ExternalLinkIcon)`
		display: inline-block;
		margin: ${({ theme }) => theme.spacings.xxxsmall};
		vertical-align: middle;
	`;
}
